import {
  createPeer,
  createBroadcastChannelTransport,
  getRpcBusChannelName,
  type JsonRpcPeer,
} from '@dynamika/rpc-core/engine';

let peer: JsonRpcPeer | null = null;

export const isDetachedHost = (): boolean =>
  /\/viewer-detached\/?$/.test(window.location.pathname);

const getPeerName = (): string => {
  if (isDetachedHost()) {
    return `d7-detached-${window.name}`;
  }

  return `d7-${window.name}`;
};

export const getPeer = (): JsonRpcPeer => {
  if (!window.name) {
    if (isDetachedHost()) {
      throw new Error('Detached window has no session SID');
    }

    window.name = crypto.randomUUID();
  }

  if (!peer) {
    peer = createPeer(
      createBroadcastChannelTransport(getRpcBusChannelName()),
      { name: getPeerName() }
    );
  }
  return peer;
};

export const resetPeer = (): void => {
  peer?.destroy();
  peer = null;
};
